import { FILTER_TYPES } from "common/Components/ExlyTable/ExlyTableFilters/filtersConstants";
import { FILTER_KEYS } from "./ScheduledExlyConnect.constants";
import { SCHEDULE_OFFERING_TYPE_NAMES } from "constants/schedule";

export const getFilterConfig = () => [
  {
    source: FILTER_KEYS.offering_type.key,
    placeholder: FILTER_KEYS.offering_type.label,
    options: SCHEDULE_OFFERING_TYPE_NAMES.map((item) => ({
      label: item.name,
      value: item.id,
    })),
    type: FILTER_TYPES.dropdown,
    disableContains: true,
  },
  {
    source: FILTER_KEYS.offering_title.key,
    placeholder: FILTER_KEYS.offering_title.label,
    type: FILTER_TYPES.input,
    disableContains: true,
  },
  {
    source: FILTER_KEYS.scheduled_from.key,
    placeholder: FILTER_KEYS.scheduled_from.label,
    type: FILTER_TYPES.date,
  },
  {
    source: FILTER_KEYS.scheduled_to.key,
    placeholder: FILTER_KEYS.scheduled_to.label,
    type: FILTER_TYPES.date,
  },
];

export const tableChipsFormatter = () => (filter, value) => {
  switch (filter) {
    case FILTER_KEYS.offering_title.key: {
      return `${FILTER_KEYS.offering_title.label}: ${value}`;
    }
    case FILTER_KEYS.offering_type.key: {
      const offeringType = SCHEDULE_OFFERING_TYPE_NAMES.find(
        (item) => item.id == value
      );
      return `${FILTER_KEYS.offering_type.label}: ${
        offeringType?.name || value
      }`;
    }
    case FILTER_KEYS.listing_uuid.key: {
      return `${FILTER_KEYS.listing_uuid.label}: ${value}`;
    }
    case FILTER_KEYS.scheduled_from.key: {
      return `${FILTER_KEYS.scheduled_from.label}: ${value}`;
    }
    case FILTER_KEYS.scheduled_to.key: {
      return `${FILTER_KEYS.scheduled_to.label}: ${value}`;
    }
    default:
      return undefined;
  }
};
